import { render, staticRenderFns } from "./FilterTextbox.vue?vue&type=template&id=0b4b5d1a&scoped=true"
import script from "./FilterTextbox.vue?vue&type=script&lang=js"
export * from "./FilterTextbox.vue?vue&type=script&lang=js"
import style0 from "./FilterTextbox.vue?vue&type=style&index=0&id=0b4b5d1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b4b5d1a",
  null
  
)

export default component.exports